import { Stack, Typography } from "@mui/material";
import { useAppDispatch } from "hooks/useReduxHooks";
import { useParams } from "react-router-dom";
import { AnalysisStatus } from "../types/companyTypes";
import { AccountAnalyticBlock } from "../components/accounts";
import { CompanyActionBlock } from "../components/company";
import { MembersBlock } from "../components/company/MembersBlock";
import { campaignsApi, useGetCampaignDetailsQuery } from "../api";
import { useEffect } from "react";
import { useNotFoundRedirect } from "../hooks";

export const AccountPage = () => {
  const { account_id, campaign_id } = useParams();
  const dispatch = useAppDispatch();

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  const { data, error } = useGetCampaignDetailsQuery(
    { account_id: account_id! },
    { skip: !account_id, refetchOnMountOrArgChange: true },
  );

  useNotFoundRedirect({ error });

  const refetchDataHandler = () => {
    dispatch(campaignsApi.util.invalidateTags(["company", "activities"]));
  };

  if (!campaign_id || !data) {
    return null;
  }

  const {
    status,
    progress,
    is_analyzed,
    scraping_update_status,
    scraping_status,
    total_members,
    can_be_analyzed,
    output: {
      summary: {
        total: { original, enriched },
      },
    },
  } = data;

  const isAnalyze = [AnalysisStatus.queued, AnalysisStatus.in_progress].some(
    (el) => el === status,
  );

  const isScraping = [AnalysisStatus.queued, AnalysisStatus.in_progress].some(
    (el) => el === scraping_status,
  );

  const isScrapingUpdate = [
    AnalysisStatus.queued,
    AnalysisStatus.in_progress,
  ].some((el) => el === scraping_update_status);

  const isProcessingDisabled = isAnalyze || isScraping || isScrapingUpdate;

  return (
    <>
      {account_id && (
        <CompanyActionBlock
          account_id={account_id}
          campaign_id={campaign_id}
          account={data}
          hasContacts={total_members > 0}
          canAnalyzeAll={can_be_analyzed || status === "in_progress"}
          progress={progress}
          is_analyzed={is_analyzed}
          status={status}
          successCallBack={refetchDataHandler}
          isDisabled={isProcessingDisabled}
        />
      )}
      <Stack gap="24px">
        <Typography variant="h4" color="custom.textDarkBlue">
          Account Analysis Results
        </Typography>
        <AccountAnalyticBlock />
      </Stack>
      <MembersBlock
        initCommitteeSelected={
          original.committee_members + enriched.committee_members
        }
        initClusterSelected={
          original.cluster_members + enriched.cluster_members
        }
      />
    </>
  );
};
